module.exports = __webpack_public_path__ + "img/ca7842213bd6045af5287128d0062e2.128cf744.jpg";